{
  "name": "@geoman-io/leaflet-geoman-free",
  "version": "2.18.3",
  "description": "A Leaflet Plugin For Editing Geometry Layers in Leaflet 1.0",
  "keywords": [
    "leaflet",
    "geoman",
    "polygon management",
    "geometry editing",
    "map data",
    "map overlay",
    "polygon",
    "geojson",
    "leaflet-draw",
    "data-field-geojson",
    "ui-leaflet-draw"
  ],
  "files": [
    "dist"
  ],
  "main": "dist/leaflet-geoman.js",
  "types": "dist/leaflet-geoman.d.ts",
  "dependencies": {
    "@turf/boolean-contains": "^6.5.0",
    "@turf/kinks": "^6.5.0",
    "@turf/line-intersect": "^6.5.0",
    "@turf/line-split": "^6.5.0",
    "lodash": "4.17.21",
    "pnpm": "^10.20.0",
    "polyclip-ts": "^0.16.8"
  },
  "devDependencies": {
    "@types/leaflet": "^1.9.21",
    "cross-env": "^10.1.0",
    "cypress": "^15.5.0",
    "esbuild": "^0.25.11",
    "eslint": "9.38.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-cypress": "5.2.0",
    "eslint-plugin-import": "2.32.0",
    "husky": "^9.1.7",
    "leaflet": "1.9.4",
    "lint-staged": "^16.2.6",
    "prettier": "3.6.2",
    "prosthetic-hand": "1.3.1",
    "typescript": "^5.9.3"
  },
  "peerDependencies": {
    "leaflet": "^1.2.0"
  },
  "scripts": {
    "start": "npm run dev",
    "dev": "cross-env DEV=true node bundle.mjs",
    "build": "node bundle.mjs",
    "test": "cypress run --browser chrome",
    "cypress": "cypress open",
    "prepare": "npm run build && husky",
    "eslint-check": "eslint --print-config . | eslint-config-prettier-check",
    "eslint": "eslint \"{src,demo}/**/*.js\" --fix ",
    "prettier": "prettier --write \"{src,demo}/**/*.{js,css}\" --log-level=warn",
    "lint": "npm run eslint && npm run prettier"
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/geoman-io/leaflet-geoman.git"
  },
  "author": {
    "name": "Geoman.io",
    "email": "sales@geoman.io",
    "url": "http://geoman.io"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/geoman-io/leaflet-geoman/issues"
  },
  "homepage": "https://geoman.io",
  "prettier": {
    "trailingComma": "es5",
    "tabWidth": 2,
    "semi": true,
    "singleQuote": true
  },
  "lint-staged": {
    "*.js": "eslint \"{src,demo}/**/*.js\" --fix",
    "*.{js,css,md}": "prettier --write \"{src,demo}/**/*.{js,css}\""
  }
}
